import { DateTime } from 'luxon';

export const getCustomStartOfDay = () => {
	const now = DateTime.local();
	const fiveAM = now.set({ hour: 5, minute: 0, second: 0, millisecond: 0 });

	// If the current time (e.g., 01:00) is BEFORE 05:00 AM today (05:00),
	// the custom day started at 05:00 AM yesterday.
	if (now < fiveAM) {
		return fiveAM.minus({ days: 1 });
	}

	// Otherwise, the custom day started at 05:00 AM today.
	return fiveAM;
};
